import { translate } from "@jsverse/transloco";
import flatpickr from "flatpickr";
import ShortcutButtonsPlugin from "shortcut-buttons-flatpickr";

interface ButtonConfig {
  label: string;
}

interface ClearButton {
  button?: ButtonConfig;
  onClick: (index: number, fp) => void;
}


export function clearButton(options: ClearButton) {
  return ShortcutButtonsPlugin({ ...{ button: { label: translate("Clear (general) - Clear") }, }, ...options });
}

export function clearButtonForNg(clearButton:HTMLElement, instance:flatpickr.Instance) {
  clearButton.textContent = translate("Clear (general) - Clear");
  clearButton.className = 'shortcut-buttons-flatpickr-button';

  clearButton.addEventListener('click', () => {
    instance.clear();
  });
  if(instance?.calendarContainer){
   instance.calendarContainer.appendChild(clearButton); 
  }
}